export const LIGHTBOX_ACTION_TYPES = {
	OPEN_LIGHTBOX: 'OPEN_LIGHTBOX',
	CLOSE_LIGHTBOX: 'CLOSE_LIGHTBOX',

	SET_LIGHTBOX_IMAGE_LIST: 'SET_LIGHTBOX_IMAGE_LIST',
	RESET_LIGHTBOX_IMAGE_LIST: 'RESET_LIGHTBOX_IMAGE_LIST',
	SET_LIGHTBOX_PHOTO_INDEX: 'SET_LIGHTBOX_PHOTO_INDEX',

}